export const environment = {
  production: true,
  debug: false,
  CONVERSATION_COLLECTION: "conversations",
  LIVECHAT_COLLECTION: "livechats",
  FRIDAY_ID: "friday",
  FRIDAY_API_TOKEN: "automagicbot",
};
